import type { UseQueryResult } from 'react-query'

export type SetState<T> = (value: T | ((prevState: T) => T)) => void

export type NarrowType<T, N> = T extends N ? T : never

export type DataOf<T extends (...params: any[]) => UseQueryResult> = Exclude<
  ReturnType<T>['data'],
  undefined
>

export type ItemOf<T extends (...params: any[]) => UseQueryResult> =
  DataOf<T> extends any[] ? DataOf<T>[number] : DataOf<T>

export type OptionalProps<T extends {}> = T | { [key in keyof T]?: undefined }

export function throwUnsupportedValue(value: never): never {
  throw new TypeError('Unsupported value: ' + value)
}
